import React, { memo } from 'react';
import styles from './popup.module.css';
import { ReactComponent as Logo } from '../../icons/logo.svg'
import { useNavigate } from 'react-router-dom';

const Popup = ({ visible, onClose, children, style, hideLogo, closeBtn, id }) => {
  const navigate = useNavigate()
  if (!visible) return null;

  return (
    <div className={styles.popup_overlay} id={id}>
      <div className={styles.popup} style={style}>
        {closeBtn && <button onClick={onClose} className={styles.close} aria-label="Close">
          &#x2715;
        </button>}
        {!hideLogo && <Logo onClick={() => navigate('/')} title='Home' className={styles.logo} />}
        {children}
      </div>
    </div>
  );
};

export default memo(Popup); 
